import React from "react";
import { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
// @ts-ignore
import ChevronDown from "!jsx!./assets/chevron-down.svg";

export default function ListboxComponent({
	selectList = [],
	selected = {
		value: "FileDate",
		description: "Sort By",
	},
	setSelected = ({ }) => { },
	label = ''
}) {	
	
	return (
		<Listbox value={selected} onChange={setSelected}>
			<div className="tw-relative">
				{/* need to render as div due to the very aggressive styling used on this site... */}
				<Listbox.Button
					as="div"
					className="
						focus:tw-outline-none tw-min-w-[150px]
						tw-relative tw-w-full tw-cursor-default tw-rounded-lg tw-bg-white
						tw-py-2 tw-pl-3 tw-pr-10 tw-text-left tw-border tw-border-solid tw-border-transparent
						focus-visible:tw-border-indigo-500 focus-visible:tw-ring-2 focus-visible:tw-ring-white focus-visible:tw-ring-opacity-75 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-secondary
					"
				>
					<span className="tw-block tw-truncate tw-font-heading">
						{label} {selected.description}
					</span>
					<span className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-2">
						<ChevronDown className="tw-text-secondary tw-w-[10px] tw-h-[10px]" />
					</span>
				</Listbox.Button>
				<Transition
					as={Fragment}
					leave="transition ease-in duration-100"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<Listbox.Options
						className="
							focus:tw-outline-none
							tw-absolute tw-z-10 tw-mt-1 tw-max-h-60 tw-w-full tw-overflow-auto
							tw-rounded-md tw-bg-white tw-py-1 tw-shadow-lg
							tw-ring-1 tw-ring-black tw-ring-opacity-5"
					>
						{selectList.map((list) => (
							<Listbox.Option
								key={list.value}
								className={({ active }) =>
									`tw-relative tw-cursor-default tw-select-none tw-py-2 tw-pl-10 tw-pr-4 ${
										active ? "tw-bg-secondary/20" : "tw-text-gray-900"
									}`
								}
								value={list}
							>
								{({ selected }) => (
									<>
										<span
											className={`tw-block tw-truncate ${
												selected ? "tw-font-medium" : "tw-font-normal"
											}`}
										>
											{list.description}
										</span>
										{selected ? (
											<span className="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-text-secondary">
												•
											</span>
										) : null}
									</>
								)}
							</Listbox.Option>
						))}
					</Listbox.Options>
				</Transition>
			</div>
		</Listbox>
	);
}
